module.exports = __webpack_public_path__ + "img/icon-left-1.04a0ac90.svg";